import React, { useState } from 'react'

import { toast } from 'react-toastify'

import Button from 'components/base/Button'
import ButtonRow from 'components/base/Button/Row'
import Content from 'components/base/Content'
import InputGroup from 'components/base/Form/InputGroup'
import { Type as InputType } from 'components/base/Form/Input/types'
import Form from 'components/base/Form'
import {
  ApiResponse,
  post,
} from 'utils/apis/insuranceLounge'
import Loading from 'components/base/Loading'

const GroupQuoteFormScreen: React.FC = (): React.ReactElement => {
  const [
    isSubmitting,
    setIsSubmitting,
  ] = useState(false)

  const onSubmit = (e: React.SyntheticEvent): void => {
    e.preventDefault()
    setIsSubmitting(true)
    const elements = e.target as typeof e.target & {
      businessName: { value: string },
      contactsName: { value: string },
      city: { value: string },
      state: { value: string },
      phoneNumber: { value: string },
      email: { value: string },
      numberOfEmployees: { value: string },
    }

    const payload = {
      business_name: elements.businessName.value, // eslint-disable-line @typescript-eslint/camelcase
      contacts_name: elements.contactsName.value, // eslint-disable-line @typescript-eslint/camelcase
      city: elements.city.value, // eslint-disable-line @typescript-eslint/camelcase
      state: elements.state.value, // eslint-disable-line @typescript-eslint/camelcase
      phone_number: elements.phoneNumber.value, // eslint-disable-line @typescript-eslint/camelcase
      email: elements.email.value, // eslint-disable-line @typescript-eslint/camelcase
      number_of_employees: elements.numberOfEmployees.value, // eslint-disable-line @typescript-eslint/camelcase
    }

    post('/contact/group-quote', payload)
      .then((resp: ApiResponse) => {
        if (resp.status !== 200) {
          throw new Error('Unable to submit the form.')
        }

        toast('Success! The form has been submitted. Someone from our team will get in touch with you soon.', { className: 'inl-success' })
      }).catch(error => {
        toast(error.message || 'An error has occurred. Please try again.')
      }).finally(() => {
        setIsSubmitting(false)
      })
  }

  return (
    <Content>
      <Form onSubmit={onSubmit}>
        <InputGroup
          type={InputType.text}
          label='Business Name'
          name='businessName'
          rules='required'
          quoteRequestField='groupQuote.businessName'
        />
        <InputGroup
          type={InputType.text}
          label='Contact Name'
          name='contactsName'
          rules='required'
          quoteRequestField='groupQuote.contactsName'
        />
        <InputGroup
          type={InputType.text}
          label='City'
          name='city'
          rules='required'
          quoteRequestField='groupQuote.city'
        />
        <InputGroup
          type={InputType.text}
          label='State'
          name='state'
          rules='required'
          quoteRequestField='groupQuote.state'
        />
        <InputGroup
          type={InputType.tel}
          label='Phone Number'
          name='phoneNumber'
          rules='required|phoneNumber'
          quoteRequestField='groupQuote.phoneNumber'
        />
        <InputGroup
          type={InputType.email}
          label='Email Address'
          name='email'
          quoteRequestField='groupQuote.email'
          rules='required|email'
        />
        <InputGroup
          type={InputType.number}
          min={1}
          label='Number of Employees'
          name='numberOfEmployees'
          rules='required|number:min=1'
          quoteRequestField='groupQuote.numberOfEmployees'
        />
        <ButtonRow>
          {(isSubmitting && (
            <Loading />
          )) || (
            <Button
              center={true}
            >
              Submit
            </Button>
          )}
        </ButtonRow>
      </Form>
    </Content>
  )
}

export default GroupQuoteFormScreen
